/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
    <style include="app-styles">
    </style>
    <div class="full-height vertical layout center-center">
        <div class="text-align-center">                
            <div class="content-align-centerprimary-dark-text-m">
                <iron-icon class="iron-icon-style-l" id="{{iconName}}" name="{{iconName}}" icon="{{iconName}}"></iron-icon>
            </div>
            <div class="mdl-grid content-align-center padding-t-zero">
                <div class="mdl-cell mdl-cell--12-col-desktop primary-dark-text-l">                
                     <oe-i18n-msg id="{{title}}" msgid="{{title}}"></oe-i18n-msg> 
                </div> 
                <div class="secondary-dark-text-m">
                  <oe-i18n-msg  id="{{description}}" msgid="{{description}}"></oe-i18n-msg>  
                </div>
            </div>
        </div>
    </div>`;

    Polymer({
        is: 'app-network-error',
        _template:template,
        properties: {
            iconName: {
                type: String,
                value: ''
            },
             title: {
                type: String,
                value: ''
            },
            description: {
                type: String,
                value: ''
            }
        }
    });
